import React from 'react';
import {
  Checkbox, FormControlLabel,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

const SectionOptOutPreview: React.FC = () => (
  <>
    <FormControlLabel
      control={(
        <Checkbox />
      )}
      label={<FormattedMessage id="survey.optOut" />}
    />
  </>
);

export default SectionOptOutPreview;
